(function () {
    'use strict';
    var m = angular.module('common');
    m.controller('BackendAuthModalController', ["$scope", "$modalInstance", "$timeout", "modulesDao", "commonDao", "modulesManager", "options", function ($scope, $modalInstance, $timeout, modulesDao, commonDao, modulesManager, options) {
        var refreshInterval = 2000;
        $scope.title = 'Authorization';
        $scope.state = 'progress';
        $scope.error = '';
        var taskId;
        var checkTimer;
        $scope.dismiss = function () {
            $timeout.cancel(checkTimer);
            $modalInstance.dismiss();
        };
        function checkStatus() {
            $timeout.cancel(checkTimer);
            modulesDao.authTaskStatus(taskId).then(function (result) {
                if (!result.data || !result.data.stage || result.data.stage === 'done') {
                    modulesManager.reloadModules().then(function () {
                        $modalInstance.close();
                    });
                    return;
                }
                if (result.data.stage === 'failed') {
                    setError(result.data.error_message);
                    return;
                }
                checkTimer = $timeout(checkStatus, refreshInterval);
            }, function () {
                setError('Unknown error has occurred');
            });
        }
        if (options.authUrl) {
            commonDao.callCustomUrl('GET', options.authUrl).then(function (result) {
                if (result.data && result.data.task_id) {
                    taskId = result.data.task_id;
                    checkTimer = $timeout(checkStatus, refreshInterval);
                    return;
                }
                setError('Unknown error has occurred');
            }, function () {
                setError('Unknown error has occurred');
            });
        } else {
            if (options.taskId) {
                taskId = options.taskId;
                checkStatus();
            } else {
                $modalInstance.close();
            }
        }
        function setError(message) {
            $scope.title = 'Authorizaton error';
            $scope.error = message;
            $scope.state = 'error';
        }
        $scope.$on('$routeChangeSuccess', function () {
            $scope.close();
        });
    }]);
    m.factory('backendAuthModal', ["$modal", "path", "$q", function ($modal, path, $q) {
        return {
            show: function (options) {
                options = $.extend(true, {}, options);
                if (!options.taskId && !options.authUrl) {
                    return $q.when();
                }
                var modalInstance = $modal.open({
                    templateUrl: path('common').ctrl('backend-auth-modal').template(),
                    controller: 'BackendAuthModalController',
                    backdrop: 'static',
                    keyboard: false,
                    resolve: { options: _.constant(options) },
                    windowClass: options.windowClass
                });
                return modalInstance.result;
            }
        };
    }]);
}());